import React, {Fragment, useRef} from "react";
import {renderCommentFields} from "../../../helpers/renderComponents.helpers";
import EditableField from "../../common/EditableField/EditableField";
import {RequestFieldKeys, RequestFields} from "../../../constants/constants";

const EDITABLE_FIELDS = [
    RequestFields.brand,
    RequestFields.model,
    RequestFields.yearOfManufacture,
    RequestFields.odometer,
    RequestFields.vin,
    RequestFields.stateNumber,
    RequestFields.maxLoanAmount,
    RequestFields.estimatedValue,
    RequestFields.pledgeStatus,
];

const PLEDGE_STATUS_OPTIONS = [
    {value: "UNKNOWN", label: "Неизвестный"},
    {value: "IN_PLEDGE", label: "В залоге"},
    {value: "NOT_IN_PLEDGE", label: "Не в залоге"},
];

const FIELD_TYPES = {
    [RequestFields.estimatedValue]: {
        type: 'number',
        decimalPlaces: 2
    },
    [RequestFields.maxLoanAmount]: {
        type: 'number',
        decimalPlaces: 2
    },
};

const RequestDetailsTable = ({
                                 details,
                                 requestFields,
                                 showCommentFields,
                                 comments,
                                 isEditing,
                                 handleCommentChange,
                                 onUpdateDetails,
                             }) => {
    const inputRefs = useRef({});
    const isFieldEditable = (label) => EDITABLE_FIELDS.includes(label);

    const getFieldConfig = (label) => {
        switch (label) {
            case RequestFields.pledgeStatus:
                return {
                    type: "select",
                    options: PLEDGE_STATUS_OPTIONS
                };
            default:
                return {
                    type: "text",
                    options: []
                };
        }
    };

    const getCommentValue = (key) => {
        if (!comments) return '';
        if (comments[`${key}Comment`] !== undefined) {
            return comments[`${key}Comment`];
        }
        if (comments[key]?.comment !== undefined) {
            return comments[key].comment;
        }
        if (comments[key] !== undefined) {
            return comments[key];
        }
        if (comments.comments?.[key] !== undefined) {
            return comments.comments[key];
        }

        return '';
    };

    const getVisibleComment = (key) => {
        switch (key) {
            case RequestFieldKeys.DESIRED_AMOUNT: {
                return details && details[RequestFieldKeys.DESIRED_AMOUNT_COMMENT];
            }
            case RequestFieldKeys.DESIRED_TERM: {
                return details && details[RequestFieldKeys.DESIRED_TERM_COMMENT];
            }
            default:
                return ''
        }
    }

    return (
        <div className="details">
            {Object.entries(requestFields).map(([key, label], index) => {
                const value = details && details[key];
                const isEditable = isFieldEditable(label);
                const commentValue = getCommentValue(key);
                const fieldConfig = FIELD_TYPES[label];
                const inputType = fieldConfig?.type || (EDITABLE_FIELDS.includes(label) && typeof value === 'number' ? 'number' : 'text');
                const {type: fieldType, options: fieldOptions} = getFieldConfig(label);

                if (value === null || value === undefined) return null;

                return (
                    <Fragment key={index}>
                        <div className="details-item">
                            <div className="details-label value">{label}</div>

                            <EditableField
                                comment={getVisibleComment(key)}
                                label={label}
                                value={value}
                                oneAppId={details?.oneAppId}
                                isEditing={isEditing && isEditable}
                                inputType={inputType}
                                fieldConfig={fieldConfig || { decimalPlaces: 0 }}
                                inputRef={(el) => (inputRefs.current[key] = el)}
                                onValueChange={(newValue) => {
                                    if (onUpdateDetails) {
                                        onUpdateDetails(key, newValue);
                                    }
                                }}
                                fieldType={fieldType}
                                options={fieldOptions}
                            />
                        </div>
                        {renderCommentFields(
                            showCommentFields,
                            key,
                            commentValue,
                            handleCommentChange(key, null, 'comments'),
                            undefined,
                            'comments'
                        )}
                    </Fragment>
                );
            })}
        </div>
    );
};

export default RequestDetailsTable;